
    <div class="container">
        <div class="row login-box" *ngIf="!isLogin">
	            <div class="col-5 left-col">
	              2020 ELECTION CSC<br><br>
	              <span style="font-size: 12px">
	             	Voter Registration form for Mizoram CSC-VLE Association
	             </span>            
	            </div>
	            <div class="col-7 right-col">
	              <div class="login-content">
	                  <div class="login-form">
	                     <div class="form-row">
	                        <div class="col-md-2 icorow">
	                          <img src="../assets/img/logo.jpg" class="logicon">
	                        </div>
	                        <div class="col-md-10 logotext">
	                          <span class="logotitle">ONLINE VOTING SYSTEM</span>
	                          <span class="logosubtitle">VOTER REGISTRATION</span>
	                        </div>
	                      </div>
	                      <div class="loginbox">
	                      	<form [formGroup]="otpForm">
	                          <div class="input-group mb-3">
	                            <div class="input-group-prepend">
	                              <span class="input-group-text">#</span>
	                            </div>
	                            <input type="text" class="form-control" formControlName="phoneNumber" [(ngModel)]="phoneNumber" name="phoneNumber" placeholder="10 Digit Mobile Number" minlength="10"h maxlength="10" >
	                          </div>
	                            <div id="recaptcha-o"></div>
	                            <div *ngIf="btnEnable">
		                            <button class="btn btn-primary px-4" [disabled]="!otpForm.valid" (click)="sendLoginCode()">Generate OTP</button>
		                        </div>
	                            <span *ngIf="resentOtp">You can resend OTP in <countdown #countdown [config]="config" (event)="handleEvent($event)"></countdown></span>	  

	                      	</form>
	                      	<br>

	                            <div class="input-group mb-3" *ngIf="windowRef.confirmationResult">
	                              <div class="input-group-prepend">
	                                <span class="input-group-text">**</span>
	                              </div>
	                              <input type="text" name="code" class="form-control" placeholder="Enter OTP" [(ngModel)]="verificationCode">
	                              <br>
	                              <button  class="btn btn-success px-4" (click)="verifyLoginCode()">Verify</button>
	                            </div>
	                      </div>
	                  </div>
              		</div>
         		 </div>
       	</div>
       	<div class="row reg-box" *ngIf="isLogin">
    		<div class="col-sm-12">
		      <form class="form-horizontal" [formGroup]="addForm" (ngSubmit)="submitData()">
		        <div class="card">
		        <div class="card-header">
		          <strong>Voter Registration Form</strong>
		        </div>

			        <div class="card-body">
			          <div class="form-group row">    
			            <div class="col-sm-6">
			              <div class="form-group">
			                <label for="name">Mobile Number</label>
			                <input type="text" class="form-control" readonly="readonly" formControlName="phoneNumber" name="phoneNumber" [(ngModel)]="mobno"/>
			              </div>
			            </div>
			            <div class="col-sm-6">
			              <div class="form-group">
			                <label for="name">CSC ID</label>
			                <input type="text" class="form-control" formControlName="cscid" name="cscid"/>
			              </div>
			            </div>
			            <div class="col-sm-12">
			              <div class="form-group">
			                <label for="name">Name of VLE</label>
			                <input type="text" class="form-control" formControlName="fullName" name="fullName"/>
			              </div>
			            </div>
			            <div class="col-sm-12">
			              <div class="form-group">
			                <label for="name">CSC Location</label>
			                <input type="text" class="form-control" formControlName="location" name="location" />
			              </div>
			            </div>
			            <div class="col-sm-6">
			              <div class="form-group">
			                <label for="name">RD Block</label>
			                <input type="text" class="form-control" formControlName="rdblock" name="rdblock" />
			              </div>
			            </div>
			            <div class="col-sm-6">
			              <div class="form-group">
			                <label for="name">District</label>
			                <input type="text" class="form-control" formControlName="district" name="district" />
			              </div>
			            </div>
			          </div>
			       	</div>

		        <div class="card-footer">
		        	<div class="row">
		        		<div class="col-sm-6"><button class="btn btn-block btn-danger" (click)="reset()">Reset Form</button></div>
		        		<div class="col-sm-6"><button class="btn btn-block btn-primary" [disabled]="!addForm.valid">Submit</button></div>
		        	</div>
		        			          
		          
		        </div>
		   </div>
		       </form>
			</div>
		</div>
   </div>
